import React, { useEffect, useState } from 'react';
import { MapPinIcon } from '@heroicons/react/24/outline';
import { api } from '../../services/api';

type Props = {
  date: string;
};

type PlacesData = {
  totalPlaces: number;
  totalOccupes: number;
  totalLibres: number;
};

export default function PlacesLibresCards({ date }: Props) {
  const [data, setData] = useState<PlacesData | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
  const fetchPlaces = async () => {
    try {
      setError('');
      const res = await api.get('/places-libres', { params: { date } });
      // Normalisation avec fallback snake_case + cast number
      const d = res.data || {};
      const normalized: PlacesData = {
        totalPlaces: Number(d.total_places ?? 0),
        totalOccupes: Number(d.occupied_places ?? 0),
        totalLibres: Number(d.free_places ?? 0),
      };
      setData(normalized);
    } catch (err: any) {
      setData(null);
      setError(err?.response?.data?.error || 'Erreur de chargement');
    }
  };

  fetchPlaces();
}, [date]);

  if (error) {
    return <div className="text-red-600">{error}</div>;
  }

  if (!data) {
    return <div className="text-gray-500">Chargement...</div>;
  }

  return (
    <article className="flex items-center gap-5 rounded-2xl border border-gray-200 bg-white p-4 dark:border-darkBorderCard dark:bg-white/[0.03]">
      <div className="inline-flex h-16 w-16 items-center justify-center rounded-xl bg-gray-100 text-gray-800 dark:bg-darkDarkGray dark:text-white/90">
        <MapPinIcon className="h-7 w-7" />
      </div>
      <div>
        <h3 className="text-2xl font-semibold text-gray-800 dark:text-white/90">
          {data.totalLibres}
        </h3>
        <p className="text-gray-500 dark:text-gray-400">Places libres</p>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Total : {data.totalPlaces} • Occupées : {data.totalOccupes}
        </p>
      </div>
    </article>
  );
}
